import React from "react";
import {NavLink} from "react-router-dom";

export const NavItemRouterLink = ({title, href}) => (
    <NavLink to={href}
             activeClassName="nav-list__item--active"
             className="nav-list__item"
    >
        {title}
    </NavLink>
);

export default NavItemRouterLink